/* global document, MouseEvent */
import React, { Component } from 'react';
import Plot from 'react-plotly.js';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Typography, Button } from '@material-ui/core';

export default class HealthGraphPlot extends Component {
  constructor(props) {
    super(props);

    this.plotRef = React.createRef();

    this.addFocusedDatePlotToPlotData = this.addFocusedDatePlotToPlotData.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const plot = document.getElementById('plotlydiv');
    plot.addEventListener('touchstart', event => this.touchHandler(event));
  }

  componentDidUpdate(prevProps) {
    const { logbookExpanded, measureSelectionExpanded } = this.props;
    if (logbookExpanded !== prevProps.logbookIsExpanded
      || measureSelectionExpanded !== prevProps.measureSelectionExpanded) {
      setTimeout(() => {
        this.plotRef.current.resizeHandler();
      }, 250);
    }
  }

  componentWillUnmount() {
    const plot = document.getElementById('plotlydiv');
    plot.removeEventListener('touchstart', this.touchHandler);
  }

  handleClick(event) {
    const { setFocusedDate } = this.props;
    const selectedDate = moment(event.points[0].x, 'YYYY-MM-DD');
    setFocusedDate(selectedDate);
  }

  touchHandler(event) {
    const touches = event.changedTouches;
    const touch = touches[0];

    const opts = {
      screenX: touch.screenX,
      screenY: touch.screenY,
      clientX: touch.clientX,
      clientY: touch.clientY,
    };

    const simulatedEvent = new MouseEvent('mousedown', opts);

    touch.target.dispatchEvent(simulatedEvent);
    event.preventDefault();
  }

  addFocusedDatePlotToPlotData() {
    const { plotData, focusedDate } = this.props;
    if (focusedDate !== null) {
      const focusedDatePlotUpperLimit = plotData[0].x[0] === undefined ? 10
        : Math.max(
          ...plotData[0].y,
        );
      return plotData.concat(
        [{
          x: [focusedDate.format('YYYY-MM-DD'), focusedDate.format('YYYY-MM-DD')],
          y: [0, focusedDatePlotUpperLimit],
          type: 'scatter',
          mode: 'lines',
          marker: { color: 'black' },
          hoverinfo: 'skip',
        }],
      );
    }
    return plotData;
  }

  render() {
    const {
      plotLayout,
      resetZoom,
    } = this.props;

    const config = { displayModeBar: false, doubleClick: false };
    const style = { width: '100%', height: '100%' };
    const plotlyPlot = (
      <Plot
        ref={this.plotRef}
        data={this.addFocusedDatePlotToPlotData()}
        layout={plotLayout}
        config={config}
        style={style}
        useResizeHandler
        onClick={this.handleClick}
      />
    );
    return (
      <React.Fragment>
        <div id="plotlydiv" style={{ touchAction: 'none', width: '100%', height: '100%' }}>
          {plotlyPlot}
        </div>
        <Button variant="contained" onClick={() => resetZoom()}>
          <Typography>
            {'Reset zoom'}
          </Typography>
        </Button>
      </React.Fragment>
    );
  }
}

HealthGraphPlot.propTypes = {
  plotData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  plotLayout: PropTypes.shape({}).isRequired,
  resetZoom: PropTypes.func.isRequired,
  logbookExpanded: PropTypes.bool.isRequired,
  measureSelectionExpanded: PropTypes.bool.isRequired,
  focusedDate: PropTypes.shape(),
  setFocusedDate: PropTypes.func,
};

HealthGraphPlot.defaultProps = {
  focusedDate: null,
  setFocusedDate: () => {},
};



// WEBPACK FOOTER //
// ./src/components/health-graph/HealthGraphPlot.jsx